export default "__VITE_ASSET__CvyOI$$w__"